import _default from './Rail';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ../node_modules/semantic-ui-react/dist/es/elements/Rail/index.js
// module id = 876
// module chunks = 0